import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AsyncPipe, JsonPipe} from '@angular/common';

@Component({
    selector: 'app-flytedge-metadata-raw',
    templateUrl: './flytedge-metadata-raw.component.html',
    styleUrl: './flytedge-metadata-raw.component.scss',
  imports: [AsyncPipe, JsonPipe]
})
export class FlytedgeMetadataRawComponent implements OnChanges {
  @Input() url: string;
  // https://preview-thales.content-sannies.castlabs.com/thales/M01512/M01512-NEONDREAMS-2024.json

  metadata$ = new BehaviorSubject<any>(null);

  constructor(private httpClient: HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url && changes.url.currentValue !== null && changes.url.currentValue !== changes.url.previousValue && changes.url) {
      this.httpClient.get(changes.url.currentValue).subscribe({
        next: newMetadata => this.metadata$.next(newMetadata),
        error: error => {
          console.error('Error fetching metadata', error);
          this.metadata$.error(error)
        }
      });
    }
  }

}
